<script lang="ts" setup>
const props = defineProps({
  data: {
    type: Object as PropType<any>
  }
})
</script>

<template>
  <div class="area">
    <div class="area__inner">
      <div class="area__left">
        <div class="area__title">{{ props.data.title }}</div>
        <div class="area__text">{{ props.data.text }}</div>
      </div>
      <div class="area__right">
        <ul class="area__lists">
          <li v-for="(item, index) in props.data.lists" :key="index">
            <div class="area__lists__left">{{ item.title }}</div>
            <div class="area__lists__right">{{ item.text }}</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.area {
  padding-top: toRem(20);
  padding-bottom: toRem(20);

  &__inner {
    display: flex;
    padding: toRem(56) toRem(32);
    background-color: rgba(241, 180, 67, 0.25);

    @include max-media(960) {
      flex-direction: column;
      align-items: center;
      padding-left: toRem(24);
      padding-right: toRem(24);
    }
  }

  &__left {
    @include max-media(960) {
      margin-bottom: toRem(32);
    }
  }

  &__right {
    flex: 1;
    padding-left: toRem(80);

    @include max-media(960) {
      padding-left: 0;
    }
  }

  &__title {
    margin-bottom: toRem(12);
    font-size: toRem(48);
    color: $color-brand-4_1;
    font-weight: 500;
    line-height: 0.8;
    font-family: $font-TextaAlt;
  }

  &__text {
    font-size: toRem(20);
    font-weight: 500;
    line-height: 1.4;
  }

  &__lists {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    li {
      display: flex;
      justify-content: space-between;
      width: calc((100% - toRem(32)) / 2);
      margin-bottom: toRem(4);
      font-size: toRem(14);
      font-weight: 400;
      line-height: 1.3;

      @include max-media(580) {
        width: 100%;
      }
    }

    &__right {
      position: relative;
      display: flex;
      align-items: center;
      text-align: right;
      flex: 1;

      &::before {
        content: '';
        margin-left: toRem(5);
        margin-right: toRem(5);
        flex: 1;
        height: 8px;
        background: transparent;
        background-image: radial-gradient($color-gray-3 20%, transparent 0),
          radial-gradient($color-gray-3 20%, transparent 0);
        background-size: 8px 8px;
        background-position:
          0 0,
          8px 8px;
      }
    }
  }
}</style>
